import { useDispatch } from "react-redux";
import Navbar from "../../../components/navbar/navbarComponent";
import {
  ActionCircleIcon,
  EyeIcon,
  EyeOffIcon,
} from "../../../components/icons/SvgIcons";
import Button from "../../../components/button";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { postNewUser } from "../../../redux/actions";
import SuccessModal from "../../../components/modals/successModal";
import ErrorModal from "../../../components/modals/errorModal";

function NuevoUsuarioComponent() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [showErrorModal, setShowErrorModal] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const handleBackClick = () => {
    navigate(-1);
  };

  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm();

  const [isPasswordVisible, setIsPasswordVisible] = useState(false);
  const [isPasswordVisible2, setIsPasswordVisible2] = useState(false);

  const contrasena = watch("contrasena");

  const onSubmit = async (data) => {
    setLoading(true);

    const now = new Date();

    const formattedDate = `${now.getFullYear()}-${String(
      now.getMonth() + 1
    ).padStart(2, "0")}-${String(now.getDate()).padStart(2, "0")} ${String(
      now.getHours()
    ).padStart(2, "0")}:${String(now.getMinutes()).padStart(2, "0")}:${String(
      now.getSeconds()
    ).padStart(2, "0")}`;

    const finalData = {
      ...data,
      fecha: formattedDate,
    };

    try {
      const response = await dispatch(postNewUser(finalData));

      if (response?.error) {
        setErrorMessage(response.error);
        setShowErrorModal(true);
        return;
      }

      setShowSuccessModal(true);
    } catch (error) {
      console.error("Error al registrar el usuario:", error);

      setErrorMessage("dni", {
        type: "server",
        message:
          error.response?.data?.error ||
          error.response?.data?.message ||
          "Hubo un error al registrar el usuario.",
      });

      setShowErrorModal(true);
    } finally {
      setLoading(false);
    }
  };

  const closeSuccessModal = () => {
    setShowSuccessModal(false);
    navigate("/usuarios");
  };

  const closeErrorModal = () => {
    setShowErrorModal(false);
  };

  return (
    <div className="bg-[#F5FAFF]">
      <Navbar />

      <button
        onClick={handleBackClick}
        className="z-50 sm:absolute sm:mt-[2.5rem] mt-[1rem] sm:ml-[5rem] lg:ml-[13rem] ml-[3rem] flex items-center justify-center p-2 rounded-full hover:drop-shadow-[3px_3px_5px_rgba(0,0,0,0.3)] transition ease-in-out duration-200"
      >
        <ActionCircleIcon className="flex flex-start h-12 drop-shadow-[2px_2px_4px_rgba(0,0,0,0.3)]" />
      </button>

      <div className="flex min-h-screen flex-col items-center bg-[#F5FAFF]">
        <div className="text-[#3d4245] sm:text-[28px] text-[20px] font-bold font-inter sm:my-[3rem] my-[1rem]">
          Nuevo usuario
        </div>

        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="w-[20rem] sm:w-[32rem] flex-col justify-start items-start gap-6 inline-flex">
            <div className="self-stretch flex-col justify-start items-start gap-2 flex">
              {/* Nombre */}
              <div className="self-stretch flex-col justify-start items-start gap-2 flex">
                <div className="text-[#3d4245] text-sm font-normal font-inter">
                  Nombre y apellido
                </div>

                <input
                  placeholder="Nombre y apellido"
                  disabled={loading}
                  className="self-stretch p-2 rounded-md border border-[#687073] text-sm font-normal font-inter"
                  {...register("nombreCompleto", {
                    required: "Ingrese el nombre y apellido por favor",
                    validate: (value) => {
                      const regex = /^[a-zA-ZáéíóúÁÉÍÓÚñÑ\s\-'´]+$/;

                      if (!regex.test(value)) {
                        return "El nombre solo puede contener letras, espacios, apóstrofes y guiones.";
                      }

                      if (value.length < 2) {
                        return "El nombre debe tener al menos 2 caracteres.";
                      }

                      if (value.length > 50) {
                        return "El nombre no debe superar los 50 caracteres.";
                      }

                      if (/\s{2,}/.test(value)) {
                        return "El nombre no debe contener espacios consecutivos.";
                      }

                      return true;
                    },
                    setValueAs: (value) =>
                      value
                        ?.trim()
                        .toLowerCase()
                        .replace(/\b\w/g, (char) => char.toUpperCase()),
                  })}
                />
              </div>

              {/* DNI */}
              <div className="self-stretch flex-col justify-start items-start gap-2 flex">
                <div className="text-[#3d4245] text-sm font-normal font-inter">
                  DNI
                </div>

                <input
                  placeholder="000000000"
                  disabled={loading}
                  className="self-stretch p-2 rounded-md border border-[#687073] text-sm font-normal font-inter"
                  type="number"
                  {...register("dni", {
                    required: "Ingrese el número de DNI por favor",
                    validate: (value) => {
                      if (!/^\d+$/.test(value)) {
                        return "El DNI solo puede contener números.";
                      }

                      if (value.length < 6 || value.length > 9) {
                        return "El DNI debe tener entre 6 y 9 dígitos.";
                      }

                      return true;
                    },
                    setValueAs: (value) => value?.trim(),
                  })}
                />
              </div>

              {/* Tipo */}
              <div className="self-stretch flex-col justify-start items-start gap-2 flex">
                <div className="text-[#3d4245] text-sm font-normal font-inter">
                  Tipo de usuario
                </div>

                <select
                  disabled={loading}
                  className="self-stretch p-2 rounded-md border border-[#687073] text-sm font-normal font-inter"
                  defaultValue=""
                  {...register("tipo", {
                    required: "Ingrese un tipo de usuario por favor",
                  })}
                >
                  <option value="" disabled>
                    Seleccionar tipo de usuario
                  </option>
                  <option value="super_admin">Super admin</option>
                  <option value="admin">Admin</option>
                  <option value="user">User</option>
                  <option value="viewer">Viewer</option>
                </select>
              </div>

              {/* Contraseña */}
              <div className="self-stretch flex-col justify-start items-start gap-2 flex">
                <div className="text-[#3d4245] text-sm font-normal font-inter">
                  Contraseña
                </div>

                <div className="relative w-[20rem] sm:w-[32rem]">
                  <input
                    type={isPasswordVisible ? "text" : "password"}
                    placeholder="Contraseña"
                    disabled={loading}
                    className="w-full text-sm font-normal font-inter outline-none rounded-md pl-4 pr-10 py-2"
                    {...register("contrasena", {
                      required: "La contraseña es obligatoria",
                      minLength: {
                        value: 7,
                        message:
                          "La contraseña debe tener más de 6 caracteres",
                      },
                      maxLength: {
                        value: 15,
                        message:
                          "La contraseña no debe exceder los 15 caracteres",
                      },
                    })}
                  />

                  <button
                    type="button"
                    disabled={loading}
                    onClick={() =>
                      setIsPasswordVisible(!isPasswordVisible)
                    }
                    className="absolute right-2 top-1/2 transform -translate-y-1/2 text-gray-500 hover:text-gray-700"
                  >
                    {isPasswordVisible ? (
                      <EyeOffIcon className="w-5 h-5" />
                    ) : (
                      <EyeIcon className="size-6" />
                    )}
                  </button>
                </div>
              </div>

              {/* Confirmación */}
              <div className="self-stretch flex-col justify-start items-start gap-2 flex">
                <div className="text-[#3d4245] text-sm font-normal font-inter">
                  Confirmación de contraseña
                </div>

                <div className="relative w-[20rem] sm:w-[32rem]">
                  <input
                    type={isPasswordVisible2 ? "text" : "password"}
                    placeholder="Contraseña"
                    disabled={loading}
                    className="w-full text-sm font-normal font-inter outline-none rounded-md pl-4 pr-10 py-2"
                    {...register("contrasena2", {
                      required: "Confirme la contraseña por favor",
                      validate: (value) =>
                        value === contrasena ||
                        "Las contraseñas no coinciden",
                    })}
                  />

                  <button
                    type="button"
                    disabled={loading}
                    onClick={() =>
                      setIsPasswordVisible2(!isPasswordVisible2)
                    }
                    className="absolute right-2 top-1/2 transform -translate-y-1/2 text-gray-500 hover:text-gray-700"
                  >
                    {isPasswordVisible2 ? (
                      <EyeOffIcon className="w-5 h-5" />
                    ) : (
                      <EyeIcon className="size-6" />
                    )}
                  </button>
                </div>
              </div>
            </div>

            {/* Errores */}
            {Object.values(errors).map((error, index) => (
              <p className="text-red-500" key={index}>
                {error.message}
              </p>
            ))}

            {/* Botones */}
            <div className="self-stretch justify-center items-center gap-2 sm:inline-flex mb-[1rem]">
              <Button
                size="lg"
                fullWidth
                type="submit"
                loading={loading}
                className="overflow-hidden sm:mb-0 mb-[0.5rem]"
              >
                Registrar usuario
              </Button>

              <Button
                variant="secondary"
                size="lg"
                fullWidth
                type="button"
                onClick={handleBackClick}
                disabled={loading}
                className="overflow-hidden"
              >
                Cancelar
              </Button>
            </div>
          </div>
        </form>
      </div>

      {showSuccessModal && (
        <SuccessModal
          closeSuccessModal={closeSuccessModal}
          message="Usuario ingresado con éxito"
        />
      )}

      {showErrorModal && (
        <ErrorModal
          closeErrorModal={closeErrorModal}
          message={errorMessage}
        />
      )}
    </div>
  );
}

export default NuevoUsuarioComponent;